import { createTypes } from "reduxsauce";

export default createTypes(`
    OPEN_MODAL
    CLOSE_MODAL
    SET_CURRENT_STEP
    SET_FORM_DATA
    UPDATE_FIELD_VALUE
    SET_LOADING
    SET_ERROR
    RESET_STATE
    SET_FORM_CONFIG_FROM_LOCAL
    SET_MODAL_CONFIG
    SET_EDIT_FLOW
    SET_INITIAL_FORM_DATA

    FETCH_CONFIG_REQUEST
    FETCH_CONFIG_SUCCESS
    FETCH_CONFIG_FAILURE

    SUBMIT_STEP_REQUEST
    SUBMIT_STEP_SUCCESS
    SUBMIT_STEP_FAILURE

    POLL_START
    POLL_SUCCESS
    POLL_FAILURE

    FETCH_FORM_METADATA_REQUEST
    FETCH_FORM_METADATA_SUCCESS
    FETCH_FORM_METADATA_FAILURE

    GUEST_LOGIN_IN_PROGRESS

    CLEAR_RESULT_PAGE_KEY

    SET_CAR_FIRST_FLOW
    SET_IMPROVE_QUOTES_FLOW
    SET_REFETCH_ON_CLOSE
    SET_RELOAD_ON_CLOSE
    SET_REDIRECT_ON_RESULT
`);
